var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70.5,
    r: 70.5,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70.5,
    r: 63.5,
    fill: "#7E42FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2209_210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.75 60.6558V92.8184L70 113.263L34.25 92.5691V51.4309L70 30.7371L97.5 46.6938L101.75 44.2005L70 26L30 48.9377V95.0623L70 118L110 95.0623V58.1626L105.75 60.6558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 92.8185H54V72.8727H74C76 72.8727 77.75 72.1247 79 70.6288C80.25 69.3822 81 67.3876 81 65.6423C81 64.645 80.75 63.8971 80.5 62.8998C80.25 62.1518 79.5 61.1545 79 60.6559C78.25 59.9079 77.5 59.4093 76.75 59.1599C76 58.9106 75 58.412 74 58.412H54V52.4282H74C77.5 52.4282 80.75 53.9242 83.25 56.4174C85.75 58.9106 87.25 62.1518 87.25 65.6423C87.25 68.3849 86.5 70.8781 85 73.122C83.5 75.1166 81.5 76.8618 79.25 77.8591C77 78.6071 74.5 78.8564 72 78.8564H60V92.8185Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 92.3197H80L74.5 82.8455C76.75 82.5962 78.75 82.3468 80.75 81.5989L87 92.3197Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.75 53.924L106 56.1679L110.25 53.924V48.9376L106 46.4443L101.75 48.9376V53.924Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2209_210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 92,
    fill: "white",
    transform: "translate(30 26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar3);
export default __webpack_public_path__ + "static/media/avatar3.7e87e228fe82f659b197780be028c5a6.svg";
export { ForwardRef as ReactComponent };